/**
 * @file シフトパターンによって勤務時間項目を変える
 */
'use strict';
import Common from '../../Utils/Common';
import Validate from './Validate';
import ApplyClass from '../../Utils/ApplyClass';

/**
 * @classname WorkingTimePattern
 * @classdesc シフトパターンによって勤務時間項目を変える
 */
export default class WorkingTimePattern {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e, controller) {
		console.log('WorkingTimePattern.constructor');
		this._$e = $e;
		this._controller = controller;
		this._$target = this._$e.closest('[data-template-area-type="delete-target"]')
		this._$workingTime = this._$target.find('.working_time2')
		this._$area = this._$e.closest('[data-template-area-type="area"]')
		$e.on('change', () => this.onChange());
		this.onChange()
	};


	/**
	 * クリックのコールバック
	 *
	 * @memberof WorkingTimePattern
	 * @return {undefined}
	 */
	onChange() {
		console.log('WorkingTimePattern.onClick');
		const val = this._$e.val()

		let i = ''
		this._$area.find('[data-template-area-type="delete-target"]').each((idx, e) => {
			const $this = $(e)
			if(this._$target.is($this) ){
				i = idx
				console.log('i::' + i);
			}
		});

		//中抜け（1）であれば、勤務時間項目を表示
		if(val === '1') {
			this._$workingTime.removeClass('hidden')
			this._$workingTime.find('input').each((index, element) => {
				const $el = $(element)
				$el.removeClass('ignore-validate')
			})

		//通し（2）であれば、勤務時間項目を非表示
		}else {
			this._$workingTime.addClass('hidden')
			this._$workingTime.find('input').each((index, element) => {
				const $el = $(element)
				$el.addClass('ignore-validate').removeClass('is-invalid')
			})
		}
	};

}
